const theme = require('../components/tailwind.config')
const resolveConfig = require('tailwindcss/resolveConfig')

const { content, ...themeWithoutContent } = theme

module.exports = resolveConfig(themeWithoutContent, {
  content: [
    './src/**/*.{js,jsx,ts,tsx,scss,css}',
    '../components/src/**/*.{js,jsx,ts,tsx,css}',
    '../data-browser/src/**/*.{js,jsx,ts,tsx,css}',
    '../dql-editor/src/**/*.{js,jsx,ts,tsx,css}',
    '../node_modules/bootstrap/**/*.{css,scss}',
    './public/index.html',
  ],
  plugins: [require('tailwind-scrollbar-hide')],
})
